export const scrollToSection = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(el, { offset: -84, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
